import { DateTime } from "luxon";
import { useEffect, useState } from "react";

const MembersOnlyRSVPCountdown = ({
    event,
}: {
    event: {
        createdAt: Date;
        membersOnlyRSVPPeriodnHours: number | null;
    };
}) => {
    const [timeLeft, setTimeLeft] = useState<string>("");

    useEffect(() => {
        const calculateTimeLeft = () => {
            const endTime = DateTime.fromJSDate(event.createdAt).plus({
                hours: event.membersOnlyRSVPPeriodnHours || 0,
            });
            const now = DateTime.now();
            const diff = endTime.diff(now, ["hours", "minutes", "seconds"]);

            const hours = Math.floor(diff.hours);
            const minutes = Math.floor(diff.minutes);
            const seconds = Math.floor(diff.seconds % 60);

            return `${hours}h ${minutes}m ${seconds}s`;
        };

        setTimeLeft(calculateTimeLeft());

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [event]);

    return (
        <div className="flex h-full items-center justify-center px-4 py-1 text-white sm:p-0">
            <p>
                <span className="font-bold">
                    Members-only RSVP period ends in {timeLeft}.{" "}
                </span>
            </p>
        </div>
    );
};

export default MembersOnlyRSVPCountdown;
